import { stylesBaseConfig } from "./base-config";
import fs from 'fs';
// const stylesBaseConfig = require('./base-config');
// const fs = require('fs');

export const marginPaddingStylesMaker = (type: string, filePath?: string) => {
  // generate margin and padding classes like m-1, p-2, etc. and insert into a css file
  const { marginClasses, paddingClasses, spacing } = stylesBaseConfig;
  const prefix = type === 'margin' ? 'm' : 'p';

  const marginPaddingStyles = Object.keys(spacing).reduce((acc, key) => {
    const value = spacing[key];
    const className = `${prefix}-${key}`;
    const marginPaddingClasses = type === 'margin' ? marginClasses : paddingClasses;
    const css = Object.keys(marginPaddingClasses).reduce((acc, key) => {
      const properties = marginPaddingClasses[key];
      const propertyValues = properties.map((property: any) => `${property}: ${value};`).join('\n');
      return `${acc}\n.${className}-${key} {\n${propertyValues}\n}`;
    }, '');

    return `${acc}\n${css}`;
  }, '');

  if (filePath) {
    fs.writeFile(filePath, marginPaddingStyles, (err: any) => {
      if (err) {
        console.error(err);
      }
    });
  }

  return marginPaddingStyles;
};

const marginStyles = marginPaddingStylesMaker('margin', './src/protected/styles/margin-styles.css');

console.log(marginStyles);